import { useState, memo } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { adminDashboardRoute } from "../../../../utils/routes/Routes";
import RowContainer from "../../../common/RowContainer";

import {
  DashboardButton,
  DashboardButtonFilled,
} from "../../../common/DashboardButton";
import { TableWrapper, StyledTable, TableHeader } from "../../style";
import "./UserStyle.less";
import { SearchRounded } from "@mui/icons-material";
import { Chip, MenuItem, Select, TableCell, TextField } from "@mui/material";
import { changePageNumberUsers } from "../../../../redux/features/usersManagement/usersManagementSlice";
import { RenderColoredCircleIconWithStatus } from "../../../common/RenderColoredCircleIconWithStatus";
import { FormattedMessage, useIntl } from "react-intl";

export const UsersList = memo(function ({
  users,
  countersData,
  onSearchStateChange,
  onFilterStateChange,
}) {
  // INIT
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();

  // STATE
  const [filter, setFilter] = useState("all");

  // FUNCTIONS
  const handleFilterChange = (e) => {
    // to lift the state up to the parent
    const value = e.target.value;
    setFilter(value);
    onFilterStateChange(value);
    dispatch(changePageNumberUsers(1));
  };

  const handleSearchChange = (e) => {
    // to lift the state up to the parent
    onSearchStateChange(e.target.value);
    dispatch(changePageNumberUsers(1));
  };

  const renderUserRows = () => {
    return users.map((row, index) => (
      <tr key={index}>
        <TableCell>
          <RenderColoredCircleIconWithStatus string={row?.status} />
        </TableCell>
        <TableCell>{row?.first_name}</TableCell>
        <TableCell>{row?.last_name}</TableCell>
        <TableCell>{row?.email}</TableCell>
        <TableCell>{row?.phone}</TableCell>
        <TableCell>
          <Link to={`${adminDashboardRoute.users}/${row?.id}`}>
            <DashboardButton type="filled">
              <FormattedMessage id="button.details" />
            </DashboardButton>
          </Link>
        </TableCell>
      </tr>
    ));
  };

  // UTILS
  const tableHeaders = [
    <div className="status-filter">
      <Select
        value={filter}
        onChange={handleFilterChange}
        MenuProps={{
          PaperProps: {
            sx: {
              width: "auto",
              backgroundColor: "var(--bkg-secondary)",
              "& .MuiMenuItem-root": {
                fontSize: "14px",
              },

              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "transparent",
              },

              "& .MuiMenuItem-root:hover": {
                backgroundColor: "var(--bkg-tertiary)",
              },
            },
          },
        }}
      >
        <MenuItem value={"all"}>
          <FormattedMessage id="button.viewAll" /> ({countersData?.total_users})
        </MenuItem>
        <MenuItem value="active">
          <FormattedMessage id="status.active" />(
          {countersData?.total_active_users})
        </MenuItem>
        <MenuItem value="banned">
          <FormattedMessage id="status.banned" /> (
          {countersData?.total_banned_users})
        </MenuItem>
        <MenuItem value="pending">
          <FormattedMessage id="status.pending" /> (
          {countersData?.total_pending_users})
        </MenuItem>
      </Select>
    </div>,
    <FormattedMessage id="table.header.firstName" />,
    <FormattedMessage id="table.header.lastName" />,
    <FormattedMessage id="table.header.email" />,
    <FormattedMessage id="table.header.phone" />,
    <FormattedMessage id="table.header.details" />,
  ];

  return (
    <TableWrapper className="users-table">
      <RowContainer end className="find-field">
        <TextField
          onChange={handleSearchChange}
          width="180px"
          variant="outlined"
          placeholder={intl.formatMessage({ id: "button.search" })}
        ></TextField>
      </RowContainer>
      <StyledTable>
        <thead>
          <tr>
            {tableHeaders.map((header, index) => (
              <TableHeader key={index}>{header}</TableHeader>
            ))}
          </tr>
        </thead>
        <tbody>{renderUserRows()}</tbody>
      </StyledTable>
    </TableWrapper>
  );
});

export default UsersList;
